import speackersViewTypes from '../components/Pages/HomePage/Speakers/speakers-view-types';

export default [
  {
    id: 1,
    name: 'Главный блок',
    name_en: 'Main section',
    visible: false,
    component: 'Intro',
    page: 'HomePage',
    params: [
      {
        id: 1,
        type: 'image',
        value: 'files/img.png',
      },
      {
        id: 2,
        type: 'introBlockBackground',
        label: 'Цвет фона блока',
        label_en: 'Background color',
        value: '',
        readStyleFromId: 'colors.primary',
      },
      {
        id: 3,
        type: 'introTitleColor',
        label: 'Цвет заголовка',
        label_en: 'Title font color',
        value: '',
        readStyleFromId: 'colors.font',
      },
      {
        id: 4,
        type: 'introTitleSize',
        label: 'Размер заголовка',
        label_en: 'Title font size',
        value: '56',
      },
      {
        id: 5,
        type: 'introDescriptionColor',
        label: 'Цвет описания',
        label_en: 'Description font color',
        value: '',
        readStyleFromId: 'colors.font'
      },
      {
        id: 6,
        type: 'introDescriptionSize',
        label: 'Размер описания',
        label_en: 'Description font size',
        value: '18',
      },
      {
        id: 7,
        type: 'mainBtnBackground',
        label: 'Цвет основной кнопки',
        label_en: 'Main button background color',
        value: '',
        readStyleFromId: 'colors.primary',
      },
      {
        id: 8,
        type: 'mainBtnText',
        label: 'Цвет текста основной кнопки',
        label_en: 'Main button font color',
        value: '',
        readStyleFromId: 'colors.font',
      },
      {
        id: 9,
        type: 'secondBtnBackground',
        label: 'Цвет кнопки подробнее',
        label_en: 'More button background color',
        value: '',
        readStyleFromId: 'colors.transparent',
      },
      {
        id: 10,
        type: 'secondBtnText',
        label: 'Цвет текста кнопки подробнее',
        label_en: 'More button font color',
        value: '',
        readStyleFromId: 'colors.font',
      },
      {
        id: 11,
        type: 'introDateColor',
        label: 'Цвет даты мероприятия',
        label_en: 'Event date font color',
        readStyleFromId: 'colors.font',
        value: '',
      },
      {
        id: 12,
        type: 'introDateSize',
        label: 'Размер даты мероприятия',
        label_en: 'Event date font size',
        value: '18',
      },
      {
        id: 13,
        type: 'introDateBackground',
        label: 'Цвет заливки даты мероприятия',
        label_en: 'Event date background color',
        readStyleFromId: 'colors.white',
        value: '',
      },
      {
        id: 14,
        type: 'introTimeColor',
        label: 'Цвет время мероприятия',
        label_en: 'Event time font color',
        value: '',
        readStyleFromId: 'colors.font',
      },
      {
        id: 15,
        type: 'introTimeSize',
        label: 'Размер время мероприятия',
        label_en: 'Event time font size',
        value: '18',
      },
      {
        id: 16,
        type: 'introTimeBackground',
        label: 'Цвет заливки время мероприятия',
        label_en: 'Event time background color',
        readStyleFromId: 'colors.primary',
        value: '',
      },
      {
        id: 17,
        type: 'introStatusColor',
        label: 'Цвет статуса мероприятия',
        label_en: 'Event status font color',
        value: '',
        readStyleFromId: 'colors.font'
      },
      {
        id: 18,
        type: 'introStatusSize',
        label: 'Размер статуса мероприятия',
        label_en: 'Event status font size',
        value: '18',
      },
      {
        id: 19,
        type: 'introStatusBackground',
        label: 'Цвет заливки статуса мероприятия',
        label_en: 'Event status background color',
        value: '',
        readStyleFromId: 'colors.accent',
      },
      {
        id: 20,
        type: 'moreDetailsBtn',
        label: 'Настройка кнопки "Подробнее"',
        label_en: 'Settings for "More" button',
        value: '3',
        linkType: 'self',
        blank: false,
        hidden: false,
      },
    ],
  },
  {
    id: 2,
    name: 'Таймер',
    name_en: 'Timer',
    visible: false,
    component: 'Counter',
    page: 'HomePage',
    params: [
      {
        id: 1,
        type: 'background',
        value: '',
        readStyleFromId: 'colors.primary',
      },
    ],
  },
  {
    id: 3,
    name: 'О конференции',
    name_en: 'About event',
    visible: false,
    isNavigational: true,
    component: 'About',
    page: 'HomePage',
    params: [
      {
        id: 1,
        type: 'background',
        value: '',
        readStyleFromId: 'colors.white',
      },
      {
        id: 2,
        type: 'checkbox',
        label: 'Отключить подложку превью',
        label_en: 'Disable substrate of preview',
        className: 'substrateDisabled',
        checked: false,
      },
    ],
  },
  {
    id: 4,
    name: 'Расписание',
    name_en: 'Schedule',
    visible: false,
    isNavigational: true,
    component: 'Schedule',
    page: 'HomePage',
    params: [
      {
        id: 1,
        key: 'scheduleBlockBackground',
        type: 'background',
        value: '',
        readStyleFromId: 'colors.white',
      },
      {
        id: 2,
        key: 'scheduleVisibility',
        type: 'checkbox',
        label: 'Отображать спикеров вертикально',
        label_en: 'Display speakers vertically',
        className: 'is-speakers-vertical',
        checked: false,
      },
      {
        id: 3,
        key: 'scheduleItemBackground',
        type: 'background',
        label: 'Цвет элемента расписания',
        label_en: 'Schedule background color',
        value: '',
        readStyleFromId: 'colors.extra',
      },
    ],
  },
  {
    id: 5,
    name: 'Программа',
    name_en: 'Program',
    visible: false,
    isNavigational: true,
    component: 'Program',
    page: 'HomePage',
    params: [
      {
        id: 1,
        type: 'background',
        value: '',
        readStyleFromId: 'colors.accent',
      },
      {
        id: 2,
        type: 'checkbox',
        label: 'Скрыть градиент',
        label_en: 'Disable gradient',
        className: 'gradientDisabled',
        checked: false,
      },
      {
        id: 3,
        type: 'programBackgound',
        label: 'Цвет заливки карточек программ',
        label_en: 'Program cards background color',
        value: '',
        readStyleFromId: 'colors.primary',
      },
    ],
  },
  {
    id: 6,
    name: 'Спикеры',
    name_en: 'Speakers',
    visible: false,
    isNavigational: true,
    component: 'Speakers',
    page: 'HomePage',
    params: [
      {
        id: 1,
        type: 'background',
        value: '',
        readStyleFromId: 'colors.white',
      },
      {
        id: 2,
        type: 'textFontColor',
        label: 'Цвет текста',
        label_en: 'Text color',
        value: '',
        readStyleFromId: 'colors.font',
      },
      {
        id: 3,
        type: 'checkbox',
        label: 'Использовать градиент подложки',
        label_en: 'Use gradient for substrate',
        className: 'is-gradient-visible',
        checked: true,
      },
      {
        id: 4,
        type: 'speakersSubstrateBackgound',
        label: 'Цвет и прозрачность заливки подложки',
        label_en: 'Background color and opacity for substrate',
        value: '',
        readStyleFromId: 'colors.primary',
      },
      {
        id: 5,
        type: 'speakersSubstrateText',
        label: 'Цвет текста на подложке',
        label_en: 'Font color on substrate',
        value: '',
        readStyleFromId: 'colors.font',
      },
      {
        id: 6,
        type: 'speakersSubstrateButtonBackgound',
        label: 'Цвет и прозрачность кнопки на подложки',
        label_en: 'Background color and opacity for button on substrate',
        value: '',
        readStyleFromId: 'colors.accent',
      },
      {
        id: 7,
        type: 'speakersSubstrateButtonText',
        label: 'Цвет текста кноки на подложке',
        label_en: 'Font color for button on substrate',
        value: '',
        readStyleFromId: 'colors.white',
      },
      {
        id: 8,
        type: 'checkbox',
        label: 'Отображать количество спикеров',
        label_en: 'Display quantity of speakers',
        className: 'is-speakers-visible',
        checked: true,
      },
      {
        id: 9,
        type: 'checkbox',
        label: '"Не показывать элемент Все спикеры',
        label_en: 'Disable element "All speakers"',
        key: 'disableSpeakers',
        checked: false,
      },
      {
        id: 10,
        key: 'blockSpeakerViewType',
        hasChilds: true,
        type: 'radio',
        label: 'Тип блока',
        label_en: 'Block type',
        params: speackersViewTypes,
        value: 'Default',
      },
      {
        id: 11,
        key: 'isSpeakerRounded',
        parent: 'blockSpeakerViewType',
        isParentValue: 'Horizontal',
        visible: false,
        type: 'checkbox',
        label: 'Отобразить круглый аватар',
        label_en: 'Display rounded avatar',
        className: 'is-speaker-rounded',
        checked: false,
      },
      {
        id: 12,
        key: 'cardQuantity',
        parent: 'blockSpeakerViewType',
        isParentValue: 'Horizontal',
        visible: false,
        type: 'number',
        label: 'Количество отображаемых карточек',
        label_en: 'Number of cards displayed',
        value: '3',
      },
      {
        id: 13,
        key: 'speakerCardColor',
        parent: 'blockSpeakerViewType',
        isParentValue: 'Cards',
        visible: false,
        type: 'background',
        label: 'Цвет карточки',
        label_en: 'Card color',
        value: '',
        readStyleFromId: 'colors.white',
      },
    ],
  },
  {
    id: 7,
    name: 'Новости',
    name_en: 'News',
    isNavigational: true,
    visible: false,
    component: 'News',
    page: 'HomePage',
    params: [
      {
        id: 1,
        type: 'background',
        value: '',
        readStyleFromId: 'colors.primary',
      },
    ],
  },
  {
    id: 8,
    name: 'Партнеры',
    name_en: 'Partners',
    visible: false,
    isNavigational: true,
    component: 'Partners',
    page: 'HomePage',
    params: [
      {
        id: 1,
        type: 'background',
        value: '',
        readStyleFromId: 'colors.white',
      },
    ],
  },
  {
    id: 9,
    name: 'Контакты',
    name_en: 'Contacts',
    visible: false,
    isNavigational: true,
    component: 'Prefooter',
    page: 'HomePage',
    params: [
      {
        id: 1,
        type: 'background',
        value: '',
        readStyleFromId: 'colors.white',
      },
    ],
  },
  {
    id: 10,
    name: 'Регистрация',
    name_en: 'Registration',
    visible: true,
    component: 'RegisterPage',
    page: 'RegisterPage',
    isSettingTurnOff: false,
    params: [
      {
        id: 1,
        type: 'image',
        value: 'files/img.png',
      },
      {
        id: 2,
        type: 'titleColor',
        label: 'Цвет заголовка страницы',
        label_en: 'Page title color',
        value: '',
        readStyleFromId: 'colors.white'
      },
      {
        id: 3,
        type: 'buttonColor',
        label: 'Цвет кнопки',
        label_en: 'Button color',
        value: '',
        readStyleFromId: 'colors.primary',
      },
      {
        id: 4,
        type: 'buttonFontColor',
        label: 'Цвет текста кнопки',
        label_en: 'Button text color',
        value: '',
        readStyleFromId: 'colors.font',
      },
      {
        id: 5,
        type: 'widgetId',
        label: 'id виджета регистрации',
        label_en: 'Widget registration id',
        value: '',
      },
    ],
  },
  {
    id: 11,
    name: 'Трансляция',
    name_en: 'Broadcast',
    visible: true,
    isInLivePage: true,
    component: 'Live',
    page: 'LivePage',
    isSettingTurnOff: true,
  },
  {
    id: 12,
    name: 'Новость',
    name_en: 'News',
    visible: true,
    isInStaticPage: true,
    component: 'StaticPage',
    page: 'StaticPage',
  },
  {
    id: 13,
    name: 'Спикеры',
    name_en: 'Speakers',
    visible: true,
    isInSpeakersPage: true,
    component: 'SpeakersPage',
    page: 'SpeakersPage',
    isSettingTurnOff: true,
  },
  {
    id: 14,
    name: 'Текстовый блок 1',
    name_en: 'Text block 1',
    visible: false,
    isNavigational: true,
    component: 'TextBlocks',
    page: 'HomePage',
    block: 'block1',
    params: [
      {
        id: 1,
        type: 'background',
        value: '',
        readStyleFromId: 'colors.primary',
      },
      {
        id: 2,
        type: 'textBlocksFontColor',
        label: 'Цвет текста',
        label_en: 'Text color',
        value: '',
        readStyleFromId: 'colors.font',
      },
      {
        id: 3,
        type: 'checkbox',
        label: 'Отображать блок',
        label_en: 'Display block',
        className: 'is-textBlocks-visible',
        checked: true,
      },
    ],
  },
  {
    id: 15,
    name: 'Текстовый блок 2',
    name_en: 'Text block 2',
    visible: false,
    isNavigational: true,
    component: 'TextBlocks',
    page: 'HomePage',
    block: 'block2',
    params: [
      {
        id: 1,
        type: 'background',
        value: '',
        readStyleFromId: 'colors.primary',
      },
      {
        id: 2,
        type: 'textBlocksFontColor',
        label: 'Цвет текста',
        label_en: 'Text color',
        value: '',
        readStyleFromId: 'colors.font',
      },
      {
        id: 3,
        type: 'checkbox',
        label: 'Отображать блок',
        label_en: 'Display block',
        className: 'is-textBlocks-visible',
        checked: true,
      },
    ],
  },
  {
    id: 16,
    name: 'Текстовый блок 3',
    name_en: 'Text block 3',
    visible: false,
    isNavigational: true,
    component: 'TextBlocks',
    page: 'HomePage',
    block: 'block3',
    params: [
      {
        id: 1,
        type: 'background',
        value: '',
        readStyleFromId: 'colors.primary',
      },
      {
        id: 2,
        type: 'textBlocksFontColor',
        label: 'Цвет текста',
        label_en: 'Text color',
        value: '',
        readStyleFromId: 'colors.font',
      },
      {
        id: 3,
        type: 'checkbox',
        label: 'Отображать блок',
        label_en: 'Display block',
        className: 'is-textBlocks-visible',
        checked: true,
      },
    ],
  },
  {
    id: 17,
    name: 'Минилендинг',
    name_en: 'Mini landing',
    visible: true,
    component: 'MiniLanding',
    page: 'HomePage',
  },
  {
    id: 18,
    name: 'Опросы на главной',
    name_en: 'Polls on the main page',
    visible: false,
    component: 'QuizSection',
    page: 'HomePage',
    params: [
      {
        id: 1,
        type: 'background',
        value: '',
        readStyleFromId: 'colors.white',
      },
      {
        id: 2,
        type: 'quizButtonColor',
        label: 'Цвет кнопки',
        label_en: 'Button color',
        value: '',
        readStyleFromId: 'colors.primary',
      },
      {
        id: 3,
        type: 'quizFontSize',
        label: 'Размер текста вопроса',
        label_en: 'Quiestion font size',
        value: '24'
      },
      {
        id: 4,
        type: 'quizPopupBackground',
        label: 'Цвет фона popup',
        label_en: 'Popup background color',
        value: '',
        readStyleFromId: 'colors.white',
      },
      {
        id: 5,
        type: 'quizAnswerBackground',
        label: 'Цвет активного ответа',
        label_en: 'Active answer background color',
        value: '',
        readStyleFromId: 'colors.primary',
      },
      {
        id: 6,
        type: 'quizFontColor',
        label: 'Цвет текста вопроса',
        label_en: 'Quiestion font color',
        value: '',
        readStyleFromId: 'colors.white',
      },
      {
        id: 7,
        type: 'quizModalFontColor',
        label: 'Цвет текста вопроса в модальном окне',
        label_en: 'Modal quiestion font color',
        value: '',
        readStyleFromId: 'colors.white',
      },
      {
        id: 8,
        type: 'quizModalButtonColor',
        label: 'Цвет кнопки в модальном окне',
        label_en: 'Modal button color',
        value: '',
        readStyleFromId: 'colors.primary',
      },
    ]
  },
  {
    id: 19,
    name: 'Popup опросы',
    name_en: 'Popup polls',
    visible: false,
    component: '',
    page: '',
    params: [
      {
        id: 1,
        type: 'quizPopupBackground',
        label: 'Цвет фона popup',
        label_en: 'Popup background color',
        value: '',
        readStyleFromId: 'colors.white',
      },
      {
        id: 2,
        type: 'quizAnswerBackground',
        label: 'Цвет активного ответа',
        label_en: 'Active answer background color',
        value: '',
        readStyleFromId: 'colors.primary',
      },
      {
        id: 3,
        type: 'quizPopupFontColor',
        label: 'Цвет текста вопроса',
        label_en: 'Quiestion font color',
        value: '',
        readStyleFromId: 'colors.white',
      },
      {
        id: 4,
        type: 'quizPopupButtonColor',
        label: 'Цвет кнопки popup опроса',
        label_en: 'Popup quiz button color',
        value: '',
        readStyleFromId: 'colors.primary',
      },
    ]
  },
];
